import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserStore } from './user/user.store';
import { requestsService } from './requests/requests.service';
import { GenesystokenService } from './genesystoken.service';
import { Auth } from 'aws-amplify';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private router: Router,
    private userStore: UserStore,
    private apiService: requestsService,
    private genesysService: GenesystokenService
  ) {}

  isTokenExpired(token: string): boolean {
    if (!token) { return true; }
    try {
      const base64Url = token.split('.')[1];
      if (!base64Url) { return false; }
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const payload = JSON.parse(decodeURIComponent(
        window.atob(base64).split('').map(c =>
          '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        ).join('')
      ));
      if (!payload.exp) { return false; }
      return Math.floor(Date.now() / 1000) > payload.exp;
    } catch {
      return false;
    }
  }

  resetAppData() {
    localStorage.clear();
    sessionStorage.clear();

    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
    }

    this.userStore.reset();
    this.apiService.clearEnvListCache();
    this.genesysService.reset();
  }

  logout() {
    this.resetAppData();
    this.router.navigate(['/login']);
  }

  /**
   * Attempts to refresh the AWS Cognito session up to `maxAttempts` times.
   * Returns the new JWT token string on success, or null after all retries are exhausted.
   * Never shows any UI toast — the caller decides what to do on final failure.
   */
  async refreshWithRetry(maxAttempts: number = 4): Promise<string | null> {
    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
      try {
        const session = await Auth.currentSession();
        return session.getIdToken().getJwtToken();
      } catch (error) {
        console.warn(`[Auth] Token refresh attempt ${attempt}/${maxAttempts} failed:`, error);
        if (attempt < maxAttempts) {
          await new Promise(resolve => setTimeout(resolve, 500 * attempt));
        }
      }
    }
    return null;
  }
}
